import type { ParamMatcher } from '@sveltejs/kit';

export const match: ParamMatcher = (param) => {
	if (param && param.toLowerCase() === 'error') {
		return true;
	}
	return false;
};
